<div class="container">
    <div class="left-section">

        <button [ngClass]="{'header-button-selected' : isBtnSelected('partners')}" class="header-button" (click)="showAllPartners()">ALL PARTNERS</button>
        <button [ngClass]="{'header-button-selected' : isBtnSelected('groups')}" class="header-button" (click)="showPartnerGroups()">PARTNER GROUPS</button>

    </div>

    <div class="right-section">



        <button *ngIf="isBtnSelected('partners')" class="add-partner-btn" class="header-button" (click)="addNewPartner()">

            <span id="add-partner-btn-content">
                <span class="btn-text">Add Partner</span>

                <span class="icon-wrapper">
                    <app-plus-icon></app-plus-icon> 
                </span>
            </span>

        </button>

        <button *ngIf="isBtnSelected('groups')" class="add-partner-btn" class="header-button" (click)="addNewPartnerGroup()">

            <span id="add-partner-btn-content">
                <span class="btn-text">Create Group</span>

                <span class="icon-wrapper">
                    <app-plus-icon></app-plus-icon> 
                </span>
            </span>

        </button>
        <button *ngIf="isBtnSelected('groups')" class="add-partner-btn" class="header-button" [disabled]="isImportingGroups" (click)="importPartnerGroups()">

            <span id="add-partner-btn-content">
                <span class="btn-text">Import Groups</span>

                <span class="icon-wrapper">
                    <app-plus-icon></app-plus-icon> 
                </span>
            </span>

        </button>

    </div>
</div>